<template lang="pug">
  figure(:class="b()")
    img(:src="image")
</template>

<script>
  export default {
    name: 'adviser-avatar',

    props: {
      image: { type: String },
    },
  };
</script>

<style lang="sass" scoped>
  .adviser-avatar
    border-radius: 50%
    overflow: hidden
</style>